import "./detials.css"
import { useNavigate } from "react-router-dom";

function ThreeServices(){
              const navigate = useNavigate();

    return(
        <>
        <div className="servicedetials">
            <div className="row">
               <div className="col-md-12">
  <div className="box">
    <i className="fas fa-heartbeat"></i>
    <h4>Chronic Disease Clinic</h4>
    <p>
        Specializes in monitoring patients with diabetes, hypertension, chronic heart and lung conditions. Individualized treatment plans include prescribed medications and lifestyle modification programs. Services cover regular organ function check-ups, educational workshops for patients and families on symptom management, and continuous support via phone or the center’s medical app.
    </p>
    <p>December 14, 2025</p>
</div>
</div>
            </div>
           <div className="row  m-2">
   <div className="buttons">
  
     <button
      className="btn w-100 btn-warning m-2"
      onClick={() => navigate(-1)}
    >
      <i className="fas fa-exclamation-triangle w-100"></i>
      Return to Service
    </button>

  
  </div>
</div>
        </div>
        </>
    )
}
export default ThreeServices